import { computed, inject, Injectable, signal } from "@angular/core";
import { rxResource, toObservable } from "@angular/core/rxjs-interop";
import { CenterUserService } from "@malirang/api-client";
import { CenterStore } from "../../../../../stores/center/center.store";

export type SetAbnormalPaymentDataParams = {
    file: File;
    teacherIds: string[];
    startMonth: string;
    endMonth: string;
};

@Injectable({ providedIn: "root" })
export class AbnormalPaymentStore {
    private readonly centerUserService = inject(CenterUserService);
    private readonly centerStore = inject(CenterStore);

    private _status = signal<"none" | "loading" | "complete">("none");
    readonly status = computed(() => this._status());

    private _params = signal<SetAbnormalPaymentDataParams | null>(null);
    readonly params = computed(() => this._params());
    readonly params$ = toObservable(this._params);

    private $teachers = rxResource({
        stream: ({ params }) =>
            this.centerUserService.centerUserControllerFindUsersByCenterId({
                centerId: params.centerId,
            }),
        params: () => ({
            centerId: this.centerStore.currentCenterId(),
        }),
    });
    teachers = computed(() =>
        this.$teachers.hasValue() ? this.$teachers.value() : [],
    );

    setStatus(status: "none" | "loading" | "complete") {
        this._status.set(status);
    }

    setAbnormalPaymentData(params: SetAbnormalPaymentDataParams | null) {
        this._params.set(params);
    }
}
